import { render, staticRenderFns } from "./totalPhoneDialog.vue?vue&type=template&id=4681318c&scoped=true"
import script from "./totalPhoneDialog.vue?vue&type=script&lang=js"
export * from "./totalPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./totalPhoneDialog.vue?vue&type=style&index=0&id=4681318c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681318c",
  null
  
)

export default component.exports